// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__EdCcv","blockMsg":"Message_blockMsg__eFdDL","avatar":"Message_avatar__ZZfgC","avatarBg":"Message_avatarBg__VIuTj","nameAuthor":"Message_nameAuthor__k4NOG"};